import { Component, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Footer } from '@components/partials/footer/footer';
import { Menu } from '@components/partials/menu/menu';
import { UiModule } from '@components/ui/ui-module';
import { environment } from '@environments/environment';

@Component({
  selector: 'op-root',
  imports: [
    RouterModule,
    UiModule,
    Menu,
    Footer
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  readonly env=environment;
  protected readonly title = signal('Legend-Binder');
}